<template>
  <div style="height: 100%; width: 100%;position: relative;">
    <div
      class="trace-layer"
      @click="showPollutantLayer = !showPollutantLayer"
      v-if="userMenuPower.controls.pollutantOperation"
    >
      <div class="n-toolbar-item n-toolbar-item-layer">
        <i class="trace-icon iconfont icon-tuceng"></i>
        <div class="n-layer-text">图层</div>
      </div>
    </div>
    <pollutant-layer
      v-if="map"
      :showPollutantLayer="showPollutantLayer"
      :map="map"
    ></pollutant-layer>

    <nMapGD
      v-if="init"
      :mapOption="mapOption"
      :timeText="month"
      :textMode="false"
      :height="mapHeight"
      :width="0 || 'auto'"
      :style="{
        position: position,
        top: top,
        left: left
      }"
      @init-map="initMap"
      @map-type-change="mapTypeChange"
      @map-style-change="mapStyleChange"
    >
    </nMapGD>

    <color-bar
      :colorType="colorType"
      :drawValue="sensortype"
      bottom="10px"
      :showTitle="showTitle"
      :colorBarDraggable="colorBarDraggable"
      :showTopNum="colorBarTopNum"
    ></color-bar>

    <map-legend-show
      :isExtraShow="isExtraShow"
      :isOpsShow="isOpsShow"
    ></map-legend-show>

    <a-tooltip placement="bottom">
      <template slot="title">
        色带数字是否显示
      </template>
      <a-icon
        v-if="userMenuPower.controls.showColorBarDrag"
        :type="colorBarTopNum ? 'eye' : 'eye-invisible'"
        class="color-bar-num-icon"
        @click="colorBarTopNum = !colorBarTopNum"
      />
    </a-tooltip>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import ColorBar from "@/components/ColorBar";
import PollutantLayer from "@/components/pollutant_layer/PollutantLayer";
import MapLegendShow from "@/components/MapLegendShow";
import {
  getBoundary,
  drawBoundary,
  GetQueryString,
  drwaNovaecsBoundary
} from "@/utils/utils";
const mapOption = {
  map: {
    // center: [116.400739, 39.916016],
    id: "map",
    skin: "amap://styles/normal",
    animateEnable: false,
    zoom: {
      value: 9,
      max: 17,
      min: 5,
      show: true
    },
    isShowSearchTool: false,
    doubleClickZoom: false
  },
  tools: {
    show: true,
    touch: false,
    fullScreen: true,
    distance: true,
    zoom: true
  }
};

export default {
  data() {
    return {
      map: null,
      mapOption: {},
      layerOpts: {
        show: true,
        gf: false,
        poi: false,
        custom: true,
        region: true
      },
      init: false,
      is_mobi: false,
      traceLayerVisible: false,
      group_id: null,
      drawRegionId: null,
      showPollutantLayer: false,
      colorBarTopNum: true
    };
  },
  computed: {
    ...mapState([
      "mapTheme",
      "hideHeader",
      "hideLeftMenu",
      "projectInfo",
      "userMenuPower",
      "authUserInfo"
    ]),
    ...mapGetters(["defaultInfo"]),
    mapHeight() {
      if (this.isLittleMap) {
        return this.height;
      } else {
        if (this.hideHeader) {
          return "100vh";
        } else {
          return this.height || "100%";
        }
      }
    }
  },
  props: [
    "height",
    "width",
    "mapId",
    "position",
    "left",
    "top",
    "isLittleMap",
    "month",
    "textTitle",
    "monthInfo",
    "sensortype",
    "colorType",
    "isExtraShow",
    "isOpsShow",
    "showTitle",
    "colorBarDraggable"
  ],
  components: {
    ColorBar,
    PollutantLayer,
    MapLegendShow
  },
  created() {
    this.group_id = this.defaultInfo.defaultGroupId;
  },
  mounted() {
    let is_mobi =
      navigator.userAgent
        .toLowerCase()
        .match(
          /(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i
        ) != null;
    let op = this.$_.cloneDeep(mapOption);
    this.is_mobi = is_mobi;
    if (is_mobi) {
      op.tools.zoom = false;
      op.tools.show = false;
    }
    let city = this.projectInfo.city || "北京";
    op.map.id = this.mapId;
    op.map.skin = this.mapTheme;
    op.map.textTitle = this.textTitle;
    op.map.center = city;
    let extraInfo = this.authUserInfo.extraInfo || {};
    this.drawRegionId = extraInfo.drawRegionId;
    let default_set = extraInfo.projectSetting || {};
    if (default_set.mapCenter) {
      const mapCenter = default_set.mapCenter;
      let sp = mapCenter.split(",");
      let lng = parseFloat(sp[0]);
      let lat = parseFloat(sp[1]);
      op.map.center = [lng, lat];
    } else {
      op.map.center = city;
    }
    if (default_set.mapZoom) {
      op.map.zoom.value = default_set.mapZoom;
    }
    this.mapOption = op;
    const useNovaRegion = extraInfo.useNovaRegion;
    if (useNovaRegion) {
      this.layerOpts.defaultShowRegion = false;
    }
    if (this.userMenuPower.controls.addLayer) {
      this.layerOpts.poi = true;
    }
    console.log(op.map);
    this.init = true;
  },
  methods: {
    initMap(map) {
      this.map = map;
      window.map = map;
      window.$Map = map;

      this.$emit("map", map);
      this.handleQuery();

      setTimeout(() => {
        console.log(this.mapTheme);
        var scaleDom = document.getElementsByClassName("amap-scalecontrol")[0];
        if (!scaleDom) return false;
        if (this.mapTheme == "amap://styles/normal") {
          scaleDom.style.color = "#000000";
        } else {
          scaleDom.style.color = "#ffffff";
        }
      }, 100);
    },
    mapTypeChange(v) {
      this.$store.commit("setMapType", v);
    },
    mapStyleChange(v) {
      if (v) {
        this.$store.commit("setMapTheme", v.value);
        localStorage.setItem("AmapTheme", v.value);
        var scaleDom = document.getElementsByClassName("amap-scalecontrol")[0];
        if (!scaleDom) return false;
        if (v.value == "amap://styles/normal") {
          scaleDom.style.color = "#000000";
        } else {
          scaleDom.style.color = "#ffffff";
        }
      }
    },
    handleQuery() {
      let center = GetQueryString("center");
      let mark = GetQueryString("mark");
      let zoom = GetQueryString("zoom") || 13;
      if (center) {
        center = JSON.parse(center);
        var centerPoint = new new AMap.LngLat(center[0], center[1])();
        this.map.setZoomAndCenter(centerPoint, zoom);
        setTimeout(() => {
          this.map.panTo(centerPoint);
          if (mark) {
            this.map.add({ position: new AMap.Marker(centerPoint) });
          }
        }, 100);
      }
    }
  }
};
</script>

<style scoped lang="less">
.base_map {
  position: relative;
  width: 100%;
  height: 100%;
}
.hiddenBtn {
  position: absolute;
  left: 200px;
  bottom: 5px;
}
.trace-layer {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  width: 40px;
  .n-toolbar-item {
    background-color: #fff;
    cursor: pointer;
    color: #000;
    text-align: center;
  }
  .n-toolbar-item-layer {
    height: 48px;
    border-radius: 4px;
  }
  .trace-icon {
    font-size: 23px;
    // color: rgba(76, 76, 76, 0.8);
    top: -1px;
    right: 9px;
    position: absolute;
  }
  .n-layer-text {
    text-align: center;
    height: 14px;
    font-size: 12px;
    font-weight: 400;
    color: #7f7f7f;
    line-height: 14px;
    position: absolute;
    left: 6px;
    bottom: 2px;
  }
}
/deep/ .n-toolbar-container {
  top: 72px;
}

.color-bar-num-icon {
  background-color: #085e9b;
  color: #ccc;
  position: absolute;
  top: 10px;
  right: 80px;
  font-size: 24px;
  padding: 4px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
